import { z } from "zod";

import { language } from "@rootreeweb/ns-helper";
import { createCustomSettings } from "@rootreeweb/zod-to-elements";

import type { FormDefinition } from "../types.js";
import ContactSalesEN from "./ContactSalesEN.js";
import { consentTextFR } from "./shared.js";

const schema = z.object({
	Prenom: z.string(),
	"Nom de famille": z.string(),
	"E-mail": z.string().email(),
	Entreprise: z.string(),
	Language: language,
	"Numéro de téléphone": z.string(),
	"Êtes-vous à la recherche d'un échantillon ou d'un devis ?": z.string(),
	"Êtes-vous intéressé par des pochettes de stockage, des pochettes personnalisées ou des rouleaux adhésifs personnalisés ?":
		z.string(), // "We do it all. Not sure what you need? Just let us know!"
	"Avez-vous déjà commandé des emballages ?": z.string(),
	"Que souhaitez-vous emballer ?": z.string(),
	"Quelles sont les dimensions approximatives de l'emballage que vous recherchez ?":
		z.string(),
	"Combien d'exemplaires souhaitez-vous commander ?": z.string(),
	"Travaillez-vous à partir d'un design existant et/ou avec un designer ?":
		z.string(),
	"Comment avez-vous entendu parler de nous ?": z.string().optional(),
	"Y-a-t-il autre chose que devrions savoir ?": z
		.string()
		.optional()
		.describe(
			createCustomSettings({
				textArea: true,
			}),
		),
	consentTextFR,
});
const contactSalesFR: FormDefinition<typeof schema.shape> = {
	signature: "9aafa59acc649ecabc04982984dfa714c173de585e8c117b2dd3e0cf0f2277f5",
	formID: "contact-sales-fr",
	schema,
	submissionOptions: {
		subject: (formState) => `Contact Sales Form (FR): ${formState["Prenom"]}`,
		preamble: "Submitted information",
		postamble:
			"Contact the Web Team if you have any issues with this the data in this email.",
		recipients: ["sales@rootree.ca", "web@rootree.ca"],
	},
	formOptions: {
		strings: {
			submitButton: "Envoyez-le dans!",
			success:
				"Envoi réussi ! Un membre de notre équipe commerciale vous contactera prochainement. Pour toute autre question, n'hésitez pas à nous contacter au 1-833-ROOTREE (766-8733).",
		},
		mapFieldsToForm: ContactSalesEN,
	},
};
export default contactSalesFR;
